import React, { useEffect } from 'react';

import ProjectsDetail from './ProjectsDetail';
import useProject from './useProject';
import { useIsSmall } from '../../../../Components/Context/Hooks/mediaQueries';
import Box from '../../../../Components/UI/Box';
import { ProjectContext } from '../../Context';
import ProjectsHeader from '../../Header/Projects/ProjectsHeader';
import LoadingSkeleton from '../../LoadingSkeleton';
import Main from '../../Main';
import MainBody from '../../Main/MainBody';
import ProjectsNavigation from '../../Navigation/Projects';
import Translations from '../../Translations';

interface ProjectsProps {
  themeLoading: boolean;
  projectId: string;
}

const Projects: React.FC<ProjectsProps> = ({ themeLoading, projectId }) => {
  const defaultLanguage = navigator.language.split('-')[0];
  const isSmall = useIsSmall();
  const { project, loading, error } = useProject(projectId);

  useEffect(() => {
    if (!project) {
      return;
    }

    document.title = `ProjectCloud - ${project.department.name}`;
  }, [project]);

  return (
    <Translations
      loader={<LoadingSkeleton style={isSmall ? 'mobile' : 'collapsed'} />}
      loading={(themeLoading || loading) && !error}
      language={defaultLanguage}
    >
      <ProjectContext.Provider
        value={{
          projectId,
          project,
          department: project?.department,
        }}
      >
        <Main>
          <ProjectsNavigation />
          <Box flex={1} display="flex" flexDirection="column" overflow="auto">
            <ProjectsHeader />

            <MainBody language={defaultLanguage} key={projectId}>
              <ProjectsDetail error={error} defaultLanguage={defaultLanguage} />
            </MainBody>
          </Box>
        </Main>
      </ProjectContext.Provider>
    </Translations>
  );
};

export default Projects;
